import styled from 'styled-components';
import { Form as FormBase } from '@unform/web';

interface FormGroupsProps {
  $columns: string;
}

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  margin: 0;

  > div {
    > button {
      align-self: flex-end;
      margin-top: 10px;
      padding: 0 15px 0 15px;
      width: 150px;
    }
  }
  .ButtonGroup {
    margin: 15px 15px 0 15px;
    display: flex;
    justify-content: space-between;
    > div {
      > button {
        &:not(:first-of-type) {
          margin-left: 5px;
        }
      }
    }
  }
  header {
    align-items: baseline;
    > button {
      margin-right: 10px;
    }
  }
`;

export const Content = styled.div`
  header {
    display: flex;
    align-items: center;
    padding: 0 0 10px 0;
  }
  padding: 0 15px 0 15px;
`;

export const Form = styled(FormBase)`
  display: flex;
  height: 100%;
  flex-direction: column;
  section {
    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 0.5px solid ${props => props.theme.fontColor};
    &:first-of-type {
      margin: 0px 0 15px 0;
    }
  }
`;

export const FormGroups = styled.div<FormGroupsProps>`
  grid-template-columns: ${props => props.$columns};
  display: grid;
  > div {
    &:not(:first-of-type) {
      margin-left: 5px;
    }
  }
`;
export const Exibidoras = styled.section`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const NovoInfo = styled.div`
  p {
    margin-bottom: 1.5rem;
    span {
      color: #0389fb;
      font-size: 1rem;
      font-weight: 700;
    }
  }
  div {
    display: flex;
    justify-content: space-between;
  }
`;
